/** @jsx jsx */
import { jsx } from 'theme-ui'

const Divider = ({ colour = '#525252', mt = 0 }) => (
  <div sx={{ background: colour, height: 1, width: '100%', mb: 16, mt }} />
)

export default Divider
